import { INTEGRATION_MANAGMENT_USER_ROLE, LICENSE_MANAGMENT_USER_ROLE } from 'config'
import { RootState } from 'reducers';

export const selectCanManageLicenses = (state: RootState) =>true // state.credentials.userRoles && state.credentials.userRoles.includes(LICENSE_MANAGMENT_USER_ROLE)
export const selectCanManageIntegrations = (state: RootState) =>true // state.credentials.userRoles && state.credentials.userRoles.includes(INTEGRATION_MANAGMENT_USER_ROLE)